<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="10" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag type="list" v-model="queryParam.companyCode" dict="biz_insurance_company,name,code" placeholder="请选择保险公司"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="地址" >
              <a-input v-model.trim="queryParam.consumerAddress" placeholder="请输入地址"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="电话" >
              <a-input v-model.trim="queryParam.consumerPhone" placeholder="请输入电话"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="8">
            <a-form-item label="纳税人识别号">
              <a-input v-model.trim="queryParam.consumerIdentification" placeholder="请输入纳税人识别号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="开户行">
              <a-input v-model.trim="queryParam.consumerBankName" placeholder="请输入开户行"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="开户行账号">
              <a-input v-model.trim="queryParam.consumerBankNumber" placeholder="请输入开户行账号"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'invoiceConfig:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('保司发票模板')" v-has="'invoiceConfig:export'">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel" v-has="'invoiceConfig:import'">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'invoiceConfig:edit'">编辑</a>
          <a-divider type="vertical" v-has="'invoiceConfig:delete'"/>
          <a-popconfirm v-has="'invoiceConfig:delete'" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          <!--<a-dropdown>-->
            <!--<a class="ant-dropdown-link">更多 <a-icon type="down" /></a>-->
            <!--<a-menu slot="overlay">-->
              <!--<a-menu-item>-->
                <!--<a @click="handleDetail(record)">详情</a>-->
              <!--</a-menu-item>-->
              <!--<a-menu-item v-has="'invoiceConfig:delete'">-->
                <!--<a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
                  <!--<a>删除</a>-->
                <!--</a-popconfirm>-->
              <!--</a-menu-item>-->
            <!--</a-menu>-->
          <!--</a-dropdown>-->
        </span>

      </a-table>
    </div>

    <biz-insurance-invoice-config-modal ref="modalForm" @ok="modalFormOk"></biz-insurance-invoice-config-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BizInsuranceInvoiceConfigModal from './modules/BizInsuranceInvoiceConfigModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '../../components/dict/JSearchSelectTag'
  import { filterObj } from '@/utils/util'

  export default {
    name: 'BizInsuranceInvoiceConfigList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      BizInsuranceInvoiceConfigModal
    },
    data () {
      return {
        description: '保司发票模板配置',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'保险公司',
            className:"column-text",
            dataIndex: 'companyCode_dictText'
          },
          {
            title:'发票类型',
            align:"center",
            dataIndex: 'invoiceType_dictText'
          },
          {
            title:'发票开具内容',
            align:"center",
            dataIndex: 'invoiceContent_dictText'
          },
          {
            title:'公司名称',
            className:"column-text",
            dataIndex: 'consumerName'
          },
          {
            title:'纳税人识别号',
            className:"column-text",
            dataIndex: 'consumerIdentification'
          },
          {
            title:'地址',
            className:"column-text",
            dataIndex: 'consumerAddress'
          },
          {
            title:'电话',
            className:"column-text",
            dataIndex: 'consumerPhone'
          },
          {
            title:'开户行',
            className:"column-text",
            dataIndex: 'consumerBankName'
          },
          {
            title:'开户行账号',
            className:"column-text",
            dataIndex: 'consumerBankNumber'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/insuranceCompanyInvoice/list",
          delete: "/bms/insuranceCompanyInvoice/delete",
          //deleteBatch: "/bms/insuranceCompanyInvoice/deleteBatch",
          exportXlsUrl: "/bms/insuranceCompanyInvoice/exportXls",
          importExcelUrl: "bms/insuranceCompanyInvoice/importExcel",
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        if(param.consumerAddress){
          param.consumerAddress = `*${param.consumerAddress}*`
        }
        if(param.consumerPhone){
          param.consumerPhone = `*${param.consumerPhone}*`
        }
        if(param.consumerBankName){
          param.consumerBankName = `*${param.consumerBankName}*`
        }
        if(param.consumerIdentification){
          param.consumerIdentification = `*${param.consumerIdentification}*`
        }
        if(param.consumerBankNumber){
          param.consumerBankNumber = `*${param.consumerBankNumber}*`
        }
        param.field = this.getQueryField()
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param)
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>